module.exports = __webpack_public_path__ + "img/tosca.e6f48b8a.png";